module.exports = {
  available: false,
  customSplashBanner: "",
  customSplashBannerColor: "#dff902",
  slug: "cancun2020",
  name: "Cancun",
  year: "2020",
  region: "Mexico",
  country: "Mexico",
  location: "Cancun, Mexico",
  subscriptionFee: 80,
  taxesAndFees: 600,
  soldOut: false,
  useHawaiiPricing: false,
  useHawaiiPhoneGate: false,
  soldOutPercent: 0,
  soldOutPercentHawaii: 0,
  soldOutReferralTrip: "kauai2021",
  soldOutReferralText: "",
  banners: [""],
  thinBar1: "",
  thinBar2: "",
  saleEndsAt: "",
  onLocationPricingAvailable: true,
  onLocationPricingCutoff: "2021-02-16T06:00:00",
  onLocationMessage: "SOLD OUT",
  requireFirstNameForNewsletter: true,
  requireLastNameForNewsletter: true,
  requireFirstNameForNewsletterFooter: false,
  requireLastNameForNewsletterFooter: false,
  allowPayChangeDuringCheckout: true,
  dates: "May 9-15, 2020",
  timeZone: "EST",
  startTime: "8:00 PM (EST)",
  checkInDay: "Saturday",
  checkInDate: "May 9, 2020",
  checkInTime: "3:00 PM (EST)",
  arrivePriorTo: "5:30 PM (EST)",
  checkOutDay: "Friday",
  checkOutDate: "May 15, 2020",
  checkOutTime: "12:00 PM (EST)",
  disableMonthlyPaymentOption: false,
  maxSubMonths: 9,
  useMaxSubMonthsCutoff: "09-28-2019",
  availabilityCutoff: "05-7-2020",
  departureAirport: "Cancun",
  departureAirCode: "CUN",
  venue: "The Ritz-Carlton, Cancun",
  venueSlug: "ritz-cancun",
  homeVideoId: 292085304,
  requestBrochureCategoryID: "3ca17a06e1",
  finalDetailsFormHash: "zbqshq518z0am8",
  finalDetailsFormEnabled: true,
  postponementFormHash: "z1h2u4g70ooyyp1",
  postponementFormEnabled: true,
  postponementFormExtHash: "z1h2u4g70ooyyp1",
  postponementFormExtEnabled: true,
  mainPageModal: {
    enabled: true,
    title: "Cancun 2020 Travelers",
    message:
      "Cancun 2020 is now Cancun 2021.  Click button below to go to Cancun 2021.",
    button: {
      text: "CANCUN 2021",
      path: "/cancun2021",
    },
  },
  tripPageModal: {
    enabled: true,
    dismissible: false,
    title: "LOVESONG | Cancun 2020 Travelers",
    messageAlignment: "left",
    message: `
      <p>LOVESONG | Cancun 2020 is now LOVESONG | Cancun 2021.  Click <a href="/cancun2021" style="color:#33ccff"><b>HERE</b></a> to go to LOVESONG | Cancun 2021.</p>
<p></p>
      <p>Important Trip Update (3/27/20): An email update has been sent to your email address on file.</p>
    `,
  },
  mapUrl:
    "https://www.google.com/maps?q=The+Ritz-Carlton,+Cancun&um=1&ie=UTF-8&sa=X&ved=0ahUKEwi2-OisuObaAhUK72MKHZOhDtAQ_AUICigB",
  perks: [
    "7 Days / 6 Nights The Ritz-Carlton, Cancun Accommodations",
    "Premium WiFi Access",
    "Complimentary Valet Parking",
    "Porterage Fees (Baggage Handling)",
    "Daily Housekeeping Gratuities",
    "Everlasting Tours OnLocation Staff",
    "Entertainment Wristbands ($500 value per person, included!)",
  ],
  subPerks: [
    "Speaking Sessions by Phenomenal Christian Speakers",
    "Performances by Chart Topping Christian Artists",
    "Morning Worship led by Musical Artists",
    "Meet & Greet Sessions with Speakers & Artists",
  ],
  lineup: [
    {
      key: "markhall",
      kind: "artist",
      name: "Mark Hall of Casting Crowns",
      nameFirst: "Mark Hall of",
      nameLast: "Casting Crowns",
    },
    {
      key: "mercyme",
      kind: "artist",
      name: "MercyMe",
      nameFirst: "MercyMe",
      nameLast: "",
    },
    {
      key: "maxlucado",
      kind: "speaker",
      name: "Max Lucado",
      nameFirst: "Max",
      nameLast: "Lucado",
    },
    {
      key: "francescabattistelli",
      kind: "artist",
      name: "Francesca Battistelli",
      nameFirst: "Francesca",
      nameLast: "Battistelli",
    },
    {
      key: "garythomas",
      kind: "speaker",
      name: "Gary Thomas",
      nameFirst: "Gary",
      nameLast: "Thomas",
      book: "sacred-marriage",
    },
    {
      key: "troytyler",
      kind: "speaker",
      name: "Troy Tyler",
      nameFirst: "Troy",
      nameLast: "Tyler",
    },
  ],
  itinerary: [
    {
      name: "Sat",
      body:
        "\
        <p>\
          <strong>Day 1 | May 9</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>\
            Resort Check-in & Love Song Registration\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Grand Opening<br />\
        Opening Acoustic Performance</strong>\
        </p>",
    },
    {
      name: "Sun",
      body:
        "\
        <p>\
          <strong>Day 2 | May 10</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship Session<br />\
            Speaking Session 1 & 2\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Date Night in Paradise*</strong>\
        </p>",
    },
    {
      name: "Mon",
      body:
        "\
        <p>\
          <strong>Day 3 | May 11</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship Session<br />\
            Speaking Session 3 & 4\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Optional Activity – Love Song Interactive*</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>",
    },
    {
      name: "Tue",
      body:
        "\
        <p>\
          <strong>Day 4 | May 12</strong>\
        </p>\
        <p>\
          Morning & Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>\
          Speaking Session 5<br />\
          Acoustic Performance\
          </strong>\
        </p>",
    },
    {
      name: "Wed",
      body:
        "\
        <p>\
          <strong>Day 5 | May 13</strong>\
        </p>\
        <p>\
          Morning & Afternoon:<br />\
          <strong>\
            Optional Activity – Chichen Itza & Cenote Experience*\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>",
    },
    {
      name: "Thu",
      body:
        "\
        <p>\
          <strong>Day 6 | May 14</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Worship Session</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>\
          Speaking Session 6<br />\
          Final Night Performance</strong>\
        </p>",
    },
    {
      name: "Fri",
      body:
        "\
        <p>\
          <strong>Day 7 | May 15</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Resort Checkout</strong>\
        </p>",
    },
  ],
  useCoupons: false,
  couponDisplay: 1,
  coupons: [
    {
      code: "C20ML1",
      value: "$800",
      labelLine1: 'Enter Promo Code: "C20ML1"',
      labelLine2: "for $800 OFF. Valid until 7/18!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "C20ML2",
      value: "$800",
      labelLine1: 'Promo Code: "C20ML2" for $800 OFF.',
      labelLine2: "Valid until 7/18/19!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "C20ML3",
      value: "$600",
      labelLine1: 'Promo Code: "C20ML3" for $600 OFF.',
      labelLine2: "Valid until 7/18/19!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "C20ML4",
      value: "$600",
      labelLine1: 'Promo Code: "C20ML4" for $600 OFF.',
      labelLine2: "Valid until 7/18/19!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "ML1C20",
      value: "$800",
      labelLine1: 'Promo Code: "ML1C20" for $800 OFF.',
      labelLine2: "Valid until 7/18/19!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "ML2C20",
      value: "$800",
      labelLine1: 'Promo Code: "ML2C20" for $800 OFF.',
      labelLine2: "Valid until 7/18/19!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "ML3C20",
      value: "$600",
      labelLine1: 'Promo Code: "ML3C20" for $600 OFF.',
      labelLine2: "Valid until 7/18/19!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "ML4C20",
      value: "$600",
      labelLine1: 'Promo Code: "ML4C20" for $600 OFF.',
      labelLine2: "Valid until 7/18/19!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "SUMMERSALE",
      value: "$800",
      labelLine1: 'Enter Promo Code: "LUCADO2020" ',
      labelLine2: "for additional $300 OFF until 8/8!",
      expiration: "2019-07-19T06:00:00",
    },
    {
      code: "SUMMERSALE2",
      value: "$200",
      labelLine1: 'Enter Promo Code: "SUMMERSALE2"',
      labelLine2: "for $200 OFF. Valid until 9/30!",
      expiration: "2019-10-01T06:00:00",
    },

    {
      code: "MHCC2019",
      value: "$200",
      labelLine1: 'Enter Promo Code: "MHCC2019"',
      labelLine2: "for $200 OFF. Valid until 9/30!",
      expiration: "2019-10-01T06:00:00",
    },
  ],
  rooms: {
    "ocean-view": {
      key: "ocean-view",
      name: "Ocean View",
      kind: "room",
      trip: "cancun2020",
      upsell: "club-oceanview-king",
      prices: {
        default: 5398,
        onlocation: 4398,
      },
      extraNightPrices: {
        default: 450,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    oceanfront: {
      key: "oceanfront",
      name: "Ocean Front",
      kind: "room",
      trip: "cancun2020",
      upsell: "club-oceanview-king",
      prices: {
        default: 5598,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront.jpg",
      header: "/images/rooms/cancun-oceanfront.jpg",
      description:
        "Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "standard-king": {
      key: "standard-king",
      name: "Standard - King Guaranteed",
      kind: "room",
      trip: "cancun2020",
      upsell: "ocean-view-king",
      prices: {
        default: 5798,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-standard-header.jpg",
      description:
        "[Limited View] Spacious 435 sqft. guest room, one King (bedding type guaranteed), luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "ocean-view-king": {
      key: "ocean-view-king",
      name: "Ocean View - King Guaranteed",
      kind: "room",
      trip: "cancun2020",
      upsell: "oceanfront-suite",
      prices: {
        default: 5998,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Spacious 435 sqft. guest room, one King (bedding type guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "club-oceanview": {
      key: "club-oceanview",
      name: "Club Ocean View",
      kind: "room",
      trip: "cancun2020",
      upsell: "club-oceanview-king",
      prices: {
        default: 6198,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 600,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "oceanfront-king": {
      key: "oceanfront-king",
      name: "Ocean Front - King Guaranteed",
      kind: "room",
      trip: "cancun2020",
      upsell: "oceanfront-suite",
      prices: {
        default: 6198,
        onlocation: 5398,
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront-king.jpg",
      header: "/images/rooms/cancun-oceanfront-king.jpg",
      description:
        "Spacious 435 sqft. guest room, one King (bedding guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "club-oceanview-king": {
      key: "club-oceanview-king",
      name: "Club Ocean View - King Guaranteed",
      kind: "room",
      trip: "cancun2020",
      upsell: "oceanfront-suite",
      prices: {
        default: 6398,
        onlocation: 5798,
      },
      extraNightPrices: {
        default: 650,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, one King (bedding type guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "club-oceanfront": {
      key: "club-oceanfront",
      name: "Club Ocean Front",
      kind: "room",
      trip: "cancun2020",
      upsell: "oceanfront-suite",
      prices: {
        default: 6598,
        onlocation: 5198,
      },
      extraNightPrices: {
        default: 650,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront.jpg",
      header: "/images/rooms/cancun-oceanfront.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "club-oceanfront-king": {
      key: "club-oceanfront-king",
      name: "Club Ocean Front - King Guaranteed",
      kind: "room",
      trip: "cancun2020",
      upsell: "oceanfront-suite",
      prices: {
        default: 6798,
        onlocation: 6398,
      },
      extraNightPrices: {
        default: 700,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront-king.jpg",
      header: "/images/rooms/cancun-oceanfront-king.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, one King (bedding guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "ocean-view-suite": {
      key: "ocean-view-suite",
      name: "Ocean View Suite",
      kind: "suite",
      trip: "cancun2020",
      upsell: "oceanfront-suite",
      prices: {
        default: 8598,
        onlocation: 7998,
      },
      extraNightPrices: {
        default: 750,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, furnished balcony with picturesque partial ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, coffee maker, and more…",
    },
    "oceanfront-suite": {
      key: "oceanfront-suite",
      name: "Ocean Front Suite",
      kind: "suite",
      trip: "cancun2020",
      upsell: "club-ocean-view-suite",
      prices: {
        default: 8998,
        onlocation: 8598,
      },
      extraNightPrices: {
        default: 850,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, furnished balcony with breathtaking oceanfront views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "club-ocean-view-suite": {
      key: "club-ocean-view-suite",
      name: "Club Ocean View Suite",
      kind: "suite",
      trip: "cancun2020",
      upsell: false,
      prices: {
        default: 10798,
        onlocation: 10598,
      },
      extraNightPrices: {
        default: 1000,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, Club Level access, furnished balcony with picturesque partial ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "club-oceanfront-suite": {
      key: "club-oceanfront-suite",
      name: "Club Ocean Front Suite",
      kind: "suite",
      trip: "cancun2020",
      upsell: false,
      prices: {
        default: 12798,
        onlocation: 11998,
      },
      extraNightPrices: {
        default: 1250,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, Club Level access, furnished balcony with breathtaking oceanfront views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "club-master-suite": {
      key: "club-master-suite",
      name: "Club Master Suite",
      kind: "suite",
      trip: "cancun2020",
      upsell: false,
      prices: {
        default: 13798,
        onlocation: 12598,
      },
      extraNightPrices: {
        default: 1500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, located on Club Level with access, three balconies with sweeping ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "ritz-carlton-suite": {
      key: "ritz-carlton-suite",
      name: "Ritz-Carlton Suite",
      kind: "suite",
      trip: "cancun2020",
      upsell: false,
      prices: {
        default: 14998,
        onlocation: 14998,
      },
      extraNightPrices: {
        default: 1750,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ritz.jpg",
      header: "/images/rooms/cancun-ritz-header.jpg",
      description:
        "Extravagant 2460 sqft. suite, one King, Club Level access, located at highest level of resort, personal terrace with chaise lounges overlooking the ocean, oversized jacuzzi on terrace, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
  },
};



// WEBPACK FOOTER //
// ./lib/trips/cancun2020.js